document.addEventListener('DOMContentLoaded', () => {
  const searchDrawer = document.getElementById('search-drawer');
  const menuToggle = document.getElementById('menu-toggle');
  const searchBtn = document.querySelector('.search-icon');
  const searchClose = document.getElementById('search-close');
  const searchInput = searchDrawer?.querySelector('.search-input');
  const searchClear = document.getElementById('search-clear');
  const resultsWrap = document.getElementById('search-results');
  const resultsList = document.getElementById('search-results-list');
  const resultsStatus = document.getElementById('search-results-status');
  const viewAllLink = document.getElementById('search-results-view-all');

  let debounceTimer = null;
  let abortController = null;

  const focusSearchInput = () => {
    if (!searchInput) return;
    requestAnimationFrame(() => {
      searchInput.focus({ preventScroll: true });
    });
  };

  const syncClearButton = () => {
    if (!searchClear || !searchInput) return;
    searchClear.hidden = searchInput.value.trim() === '';
  };

  const clearResults = () => {
    if (resultsList) resultsList.innerHTML = '';
    if (resultsStatus) resultsStatus.textContent = '';
    if (viewAllLink) {
      viewAllLink.hidden = true;
      viewAllLink.href = '/search';
    }
    resultsWrap?.setAttribute('hidden', '');
  };

  const extractProducts = (data) => {
    if (!data) return [];
    if (Array.isArray(data.resources?.results?.products)) return data.resources.results.products;
    if (Array.isArray(data.resources?.products)) return data.resources.products;
    if (Array.isArray(data.products)) return data.products;
    return [];
  };

  const productImage = (product) => {
    if (!product) return '';
    if (typeof product.image === 'string') return product.image;
    if (product.image?.url) return product.image.url;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image?.url) return product.featured_image.url;
    if (product.featured_image?.src) return product.featured_image.src;
    return '';
  };

  const productMatchesTerm = (product, term) => {
    const q = (term || '').trim().toLowerCase();
    if (!q) return false;
    const haystack = [product.title, product.product_type, product.type, product.vendor, ...(product.tags || [])]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    if (haystack.includes(q)) return true;
    const words = q.split(/\s+/).filter((w) => w.length > 1);
    return words.length > 0 && words.every((w) => haystack.includes(w));
  };

  const filterRelevantProducts = (term, products) =>
    (products || []).filter((product) => productMatchesTerm(product, term));

  const renderResults = (term, products) => {
    if (!resultsWrap || !resultsList || !resultsStatus) return;

    resultsList.innerHTML = '';

    if (!term) {
      clearResults();
      return;
    }

    const relevant = filterRelevantProducts(term, products);

    resultsWrap.removeAttribute('hidden');

    if (viewAllLink) {
      viewAllLink.hidden = false;
      viewAllLink.href = `/search?q=${encodeURIComponent(term)}&type=product`;
    }

    if (!relevant.length) {
      resultsStatus.textContent = 'No results found';
      return;
    }

    resultsStatus.textContent = '';
    relevant.forEach((product) => {
      const li = document.createElement('li');
      li.className = 'search-results__item';

      const href = product.url || '#';
      const image = productImage(product);
      const title = product.title || '';

      li.innerHTML = `
        <a href="${href}" class="search-results__link">
          <span class="search-results__media">
            ${
              image
                ? `<img src="${image}" alt="" width="64" height="64" loading="lazy">`
                : `<span class="search-results__placeholder">CLAREZA</span>`
            }
          </span>
          <span class="search-results__meta">
            <span class="search-results__title">${title}</span>
          </span>
        </a>
      `;
      resultsList.appendChild(li);
    });
  };

  const fetchResults = (term) => {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const jsonUrl =
      `/search/suggest.json?q=${encodeURIComponent(term)}` +
      `&resources[type]=product` +
      `&resources[limit]=8` +
      `&resources[options][unavailable_products]=last` +
      `&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

    fetch(jsonUrl, {
      signal: abortController.signal,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((res) => {
        if (!res.ok) throw new Error('search failed');
        return res.json();
      })
      .then((data) => {
        const products = extractProducts(data);
        if (products.length) {
          renderResults(term, products);
          return;
        }

        // Fallback: section-rendered predictive search HTML
        const sectionUrl =
          `${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(term)}` +
          `&resources[type]=product&resources[limit]=8&section_id=predictive-search`;

        return fetch(sectionUrl, {
          signal: abortController.signal,
          credentials: 'same-origin',
        })
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const items = [];
            doc.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item a').forEach((a) => {
              const title =
                a.querySelector('.predictive-search__item-heading')?.textContent?.trim() ||
                a.getAttribute('aria-label') ||
                '';
              const img = a.querySelector('img')?.getAttribute('src') || '';
              if (title && a.href) {
                items.push({ title, url: a.href, image: img });
              }
            });
            renderResults(term, items);
          });
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        if (resultsStatus) {
          resultsWrap?.removeAttribute('hidden');
          resultsStatus.textContent = 'Unable to load results';
          if (viewAllLink) {
            viewAllLink.hidden = false;
            viewAllLink.href = `/search?q=${encodeURIComponent(term)}&type=product`;
          }
        }
      });
  };

  const openSearch = () => {
    window.ClarezaDrawers?.open('search');
    searchDrawer.classList.add('open');
    focusSearchInput();
  };

  const closeSearch = () => {
    searchDrawer.classList.remove('open');
    if (!document.getElementById('menu-drawer')?.classList.contains('open')) {
      document.body.style.overflow = '';
    }
  };

  searchBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    if (searchDrawer.classList.contains('open')) closeSearch();
    else openSearch();
  });

  searchClose?.addEventListener('click', closeSearch);

  searchInput?.addEventListener('input', () => {
    syncClearButton();
    const term = searchInput.value.trim();
    clearTimeout(debounceTimer);

    if (!term) {
      clearResults();
      return;
    }

    if (resultsStatus) {
      resultsWrap?.removeAttribute('hidden');
      resultsStatus.textContent = 'Searching…';
    }

    debounceTimer = setTimeout(() => fetchResults(term), 250);
  });

  searchClear?.addEventListener('click', () => {
    if (!searchInput) return;
    searchInput.value = '';
    syncClearButton();
    clearResults();
    focusSearchInput();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchDrawer.classList.contains('open')) closeSearch();
  });

  menuToggle?.addEventListener('click', () => {
    if (searchDrawer.classList.contains('open')) closeSearch();
  });

  syncClearButton();
});
